import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { OrganizationHoldingService } from '@core/services/entities/organization-holding.service';
import { OrganizationHoldingResponseDto } from '@domain/organization-holding/dtos/organization-holding.response.dto';
import { OrganizationHoldingRepository } from '@domain/organization-holding/repositories/organization-holding.repository';
import { Observable } from 'rxjs';
import { GetOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/get-organization-holding.request.dto';
import { CreateOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/create-organization-holding.request.dto';
import { ListOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/list-organization-holding.request.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UpdateOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/update-organization-holding.request.dto';
import { UpdateStateOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/update-state-organization-holding.request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
    providedIn: 'root',
})
export class OrganizationHoldingRepositoryService
    implements OrganizationHoldingRepository {
    constructor(private organizationHoldingService: OrganizationHoldingService) { }
    create(
        request: CreateOrganizationHoldingRequestDto,
    ): Observable<ApiResponse<OrganizationHoldingResponseDto>> {
        return this.organizationHoldingService.create(request);
    }
    update(
        request: UpdateOrganizationHoldingRequestDto,
    ): Observable<ApiResponse<OrganizationHoldingResponseDto>> {
        return this.organizationHoldingService.update(request);
    }
    updateState(
        request: UpdateStateOrganizationHoldingRequestDto,
    ): Observable<ApiResponse<OrganizationHoldingResponseDto>> {
        return this.organizationHoldingService.updateState(request);
    }
    list(
        request: ListOrganizationHoldingRequestDto,
    ): Observable<ApiResponse<PageableResponse<OrganizationHoldingResponseDto>>> {
        return this.organizationHoldingService.list(request);
    }
    show(
        request: RefId,
    ): Observable<ApiResponse<OrganizationHoldingResponseDto>> {
        return this.organizationHoldingService.show(request);
    }
    get(
        request: GetOrganizationHoldingRequestDto,
    ): Observable<ApiResponse<OrganizationHoldingResponseDto[]>> {
        return this.organizationHoldingService.get(request);
    }
}
